import { Injectable, inject } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { from, Observable } from "rxjs";
import { ForkalkylsmallarComponent } from "./forkalkylsmallar.component";

@Injectable({
    providedIn: "root"
})
export class MinaForkalkylsmallarDialogService {
    private readonly ngbModalService = inject(NgbModal);

    minaForkalkylsmallarModal(): Observable<any> {
        if (!this.ngbModalService.hasOpenModals()) {
            const modalRef = this.ngbModalService.open(ForkalkylsmallarComponent, {
                keyboard: false,
                backdrop: "static",
                size: "lg"
            });
            modalRef.componentInstance.isModalActive = true;
            return from(modalRef.result);
        }

        return from(null);
    }
}
